import React from 'react';
import { Flex, Text, Box } from '@chakra-ui/react';
import TopBidder from './TopBidder';

const AuctionEnded = ({ topBider, auction, price_usd, finish }) => {
  return (
    <Box mb="15px">
      <Text fontWeight="bold" color="#fe383f" mb="6px" fontSize="14px">
        Auction ended
      </Text>
      {topBider ? <TopBidder topBider={topBider} auction={auction} price_usd={price_usd} finish={finish} /> : null}
    </Box>
  );
};

export default AuctionEnded;
